<template>
    <section class="assessmentSection questionsSection page-aocSearch">
        <div class="pageContent">
            <header class="sectionHeader">
            <div class="pageTitle hasSubtitle">Start typing the name of an area that concerns you</div>
            <div class="pageSubtitle">
                We will help you identify areas of your home to protect, and give you advice about how to protect those areas.
            </div>
        </header>
        <AocView>
            <div class="multiselect-room" ref="searchContainer" :class="{ dirty: areaOfConcern.name }">

                <input ref="input" type="text" placeholder="" v-model="searchString" />

                <div class="aocSearchResultsContainer" v-if="filteredAreas.length > 0">
                    <div class="aocSearchFade top" />
                    <div class="aocSearchResults">
                        <div v-for="area in filteredAreas" class="aocSearchResult" @click="selectRoom(area)">
                            <img :src="area.image" /> <span class="text">{{ area.name }}</span>
                        </div>
                    </div>
                    <div class="aocSearchFade bottom" />
                </div>

                <div v-if="noResults" class="aocSearchResults aocNoResults">
                    No areas were found with that name
                </div>
            </div>

            <div class="aocSearchEmptyState" v-if="!inputDirty">
                <img src="/img/areaSearch.png" />
                <div>
                    Type the name of an area
                    <br>
                    you want to protect
                </div>
            </div>
        </AocView>

        
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import uuid from 'uuid/v1'
import AocView from '../../components/AocView.vue'
export default {
    components: {
        AocView
    },
    data: () => ({
        searchString: ''
    }),
    computed: {
        ...mapState(['lead', 'areaOfConcern', 'availableAreas', 'emptyAreaOfConcern']),

        filteredAreas() {
            let that = this
            if (this.inputDirty) {
                let areas = this.availableAreas.filter(area => {
                    const nameNormalized = area.name.toLowerCase()
                    const searchNormalized = that.searchString.toLowerCase()
                    return nameNormalized.includes(searchNormalized)
                })
                return areas
            }

            return []
        },

        noResults() {
            return this.inputDirty && this.filteredAreas.length < 1
        },

        inputDirty() { 
            return this.searchString.length > 1
        }
    },
    methods: {
        ...mapActions([
            'updateAreaOfConcern',
            'handleDuplicateArea',
            'incrementAocSectionIndex'
        ]),

        selectRoom(areaOfConcern) {
            this.resetAreaOfConcern()
            let aoc = areaOfConcern
            aoc.id = uuid()
            this.handleDuplicateArea(aoc).then(duplicates => {
                if (duplicates.length < 1) {
                    this.incrementAocSectionIndex()
                    this.updateAreaOfConcern(aoc)
                    if (this.$route.path !== '/assessment/areas-of-concern') {
                        this.$router.push('/assessment/areas-of-concern')
                    }
                }
            })
        },

        resetAreaOfConcern() {
            // Clear current area of concern
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            if (this.$route.path !== '/assessment/areas-of-concern') {
                this.$router.push('/assessment/areas-of-concern')
            }
        }
    },
    mounted() {
        this.$refs.input.focus()
    }
}
</script>

<style lang="css"></style>
